const PERMISSION_KEY= "core:membership_cash_plan";
const PAGE_URL = {
    MEMBERSHIP_CASH_PLAN_PAGE: "/admin/core/membership-cash-plan"
}

export {PERMISSION_KEY, PAGE_URL}

